export enum AnticipatedCapabilities {
  targetNative4k = "targetNative4k",
  hdr = "hdr",
  crossGenerationalContent = "crossGenerationalContent",
  cloudAware = "cloudAware",
}

export enum XsCapabilities {
  rayTracing = "rayTracing",
  highFrameRate = "highFrameRate",
  directStorage = "directStorage",
}
